// extracted by mini-css-extract-plugin
export default {"collectionDetail":"CollectionsDetail_collectionDetail__Appij"};